<template>
	<div class="business">
		<!-- <div class="fx-header">
			<p>企业设置</p>
		</div> -->
		<div class="store-name">
			<span>
				<i class="el-icon-back" @click="goBack"></i>
			</span>
			<span>{{id ? '编辑' : '新增'}}自提点</span>
		</div>
		<div class="business-body">
            <el-form :model="ruleForm" :rules="rules" :inline-message='true' ref="ruleForm" label-position='right' label-width="114px" class="box">
                <el-form-item label="自提点名称:" prop='selfPickName'>
                    <el-input class='input-box' size='mini' v-model="ruleForm.selfPickName" :maxlength='30'></el-input>
                </el-form-item>
                <el-form-item label="联系人姓名:" prop='selfPickLinkName'>
                    <el-input  class='input-box' size='mini' v-model="ruleForm.selfPickLinkName" :maxlength='10'></el-input>
                </el-form-item>
                <el-form-item label="电话号码:" prop='selfPickTel'>
                    <el-input  class='input-box' size='mini' v-model="ruleForm.selfPickTel" maxlength="11"></el-input>
                </el-form-item>
                <el-form-item label="自提费用:" prop='selfPickMoney'>
                    <el-input  class='input-box' size='mini' v-model="ruleForm.selfPickMoney"></el-input>
                </el-form-item>
               <el-form-item label="所在地区:" prop="postion" ref="postion">
					<el-select v-model="ruleForm.showProvince" size='mini' class='select-box region' @change='provinceChange($event, "ruleForm")' placeholder="请选择省份">
						<el-option
							v-for="(item,index) in provinceList"
							:key="index"
							:label="item.name"
							:value="JSON.stringify(item)"
							ref="province">
						</el-option>
					</el-select>
					<el-select v-model="ruleForm.showCity"  size='mini' class='select-box' @change='cityChange($event, "ruleForm")' placeholder="请选择城市">
						<el-option
							v-for="(item,index) in cityList"
							:key="index"
							:label="item.name"
							:value="JSON.stringify(item)">
						</el-option>
					</el-select>
					<el-select v-model="ruleForm.showDistrict"  size='mini' class='select-box' @change='districtChange($event, "ruleForm")' placeholder="请选择区域">
						<el-option
							v-for="(item,index) in areaList"
							:key="index"
							:label="item.name"
							:value="item.code">
						</el-option>
					</el-select>
				</el-form-item>
				<!-- <el-form-item label="街道地址:" prop='address' class="input540">
					<el-input class='long-input' @input="addressInput" size='mini' v-model="ruleForm.address" :maxlength='100' placeholder="请输入街道地址" id="searchInput"></el-input>
				</el-form-item> -->
				<el-form-item label="详细地址:" prop="selfPickAddress" class="input540" style="height:102px">
					<el-input type="textarea" size='mini' v-model="ruleForm.selfPickAddress" :rows='5' :maxlength='100' placeholder='请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元等信息' resize="none" style="height:100px;width:500px"></el-input>
				</el-form-item>
				<el-form-item label="自提时间:" prop="week">
					<div>
						<el-select v-model="ruleForm.week" multiple collapse-tags size='mini' class='select-box' @change='weekChange' placeholder="请选择星期">
							<el-option label="全部" value="0"></el-option>
							<el-option
								v-for="item in weekList"
								:key="item.id"
								:label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
						<el-button size='mini' class="time-btn" icon="el-icon-plus" circle v-if="!addTimeShow && ruleForm.week.length !== 8" @click="addTimeClick"></el-button>
					</div>
					<div class="all-time-box">
						<div v-for="(item, index) in timeList" :key="index" class="time-item">
							<el-time-select
								v-model="item.startdate"
								class="date-box"
								:clearable="false"
								format="HH:mm"
								value-format="HH:mm"
								size="mini"
								:picker-options="{
									selectableRange: `00:00:00 -${item.enddate ? item.enddate + ':00' : '23:00:00'}`,
									step: '01:00',
									start: '00:00',
									end: !item.enddate ? '23:00' : item.enddate
								}"
								placeholder="请选择"
								@change="changeStartTime(item, index)"
							></el-time-select> ~
							<el-time-select
								v-model="item.enddate"
								class="date-box"
								:clearable="false"
								format="HH:mm"
								value-format="HH:mm"
								size="mini"
								:picker-options="{
									selectableRange: `${item.startdate ? item.behinddate + ':00' : '00:00:00'}-24:00:00`,
									step: '01:00',
									start: item.behinddate,
									end: '24:00'
								}"
								placeholder="请选择"
								@change="changeEndTime(item, index)"
							></el-time-select>
							<span style="color:#F56C6C;margin-left: 20px;" v-if="item.errorFlag || item.errorFlag2">时间段不能交叉</span>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="自提时间:" prop="week2" v-show="addTimeShow">
					<div>
						<el-select v-model="ruleForm.week2" multiple collapse-tags size='mini' class='select-box' @change='weekChange' placeholder="请选择星期">
							<el-option label="全部" value="0" disabled></el-option>
							<el-option
								v-for="item in weekList"
								:key="item.id"
								:disabled="ruleForm.week.includes(item.id)"
								:label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
						<el-button size='mini' class="time-btn" icon="el-icon-minus" circle @click="delTimeClick"></el-button>
					</div>
					<div class="all-time-box">
						<div v-for="(item, index) in timeList2" :key="index" class="time-item">
							<el-time-select
								v-model="item.startdate"
								class="date-box"
								format="HH:mm"
								value-format="HH:mm"
								:clearable="false"
								size="mini"
								:picker-options="{
									selectableRange: `00:00:00 -${item.enddate ? item.enddate + ':00' : '23:00:00'}`,
									step: '01:00',
									start: '00:00',
									end: !item.enddate ? '23:00' : item.enddate
								}"
								placeholder="请选择"
								@change="changeStartTime2(item, index)"
							></el-time-select> ~
							<el-time-select
								v-model="item.enddate"
								class="date-box"
								:clearable="false"
								format="HH:mm"
								value-format="HH:mm"
								size="mini"
								:picker-options="{
									selectableRange: `${item.startdate ? item.behinddate + ':00' : '00:00:00'}-24:00:00`,
									step: '01:00',
									start: item.behinddate,
									end: '24:00'
								}"
								placeholder="请选择"
								@change="changeEndTime2(item, index)"
							></el-time-select>
							<span style="color:#F56C6C;margin-left: 20px;" v-if="item.errorFlag || item.errorFlag2">时间段不能交叉</span>
						</div>
					</div>
				</el-form-item>
            </el-form>
        </div>
        <div class="business-foot" :disabled="AuthorityList['01_0002_0001_00']">
            <el-button class="btn" type="primary" size='small' @click="submitForm('ruleForm')">保 存</el-button>
        </div>
	</div>
</template>

<script>
import { cityData } from '@/js/location/city.js'
import { provinceData } from '@/js/location/province.js'
import { geography } from '@/js/location/geography.js'
import { areaData } from '@/js/location/areaData.js'
export default {
	name: 'business',
	data () {
		var postion = (rule, value, callback) => {
			if (this.isTrue === true) {
				return callback(new Error('请选择位置'))
			} else {
				callback()
			}
		}
		var area = (rule, value, callback) => {
			if (this.waringArea === true) {
				return callback(new Error('请选择位置'))
			} else {
				callback()
			}
		}
		var week = (rule, value, callback) => {
			if (this.isWeek === true) {
				return callback(new Error('请选择自提时间'))
			} else {
				callback()
			}
		}
		var week2 = (rule, value, callback) => {
			if (this.isWeek2 === true) {
				return callback(new Error('请选择自提时间'))
			} else {
				callback()
			}
		}
		var phone = (rule, value, callback) => {
			var reg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/
			if (!(reg.test(value))) {
				return callback(new Error('请输入正确手机号'))
			} else {
				callback()
			}
		}
		var isNull = (rule, value, callback) => {
			var reg = /^[\s\S]*.*[^\s][\s\S]*$/
			if (!(reg.test(value))) {
				return callback(new Error(''))
			} else {
				callback()
			}
		}
		return {
			AuthorityList: {
				'01_0002_0001_00': false
			},
			clddock: '',
			src: '',
			area: '',
			id: '',
			province: '',
			city: '',
			uploadError: false,
			provinceListTotal: [],
			provinceList: [],
			cityList: [],
			areaList: [],
			regionList: [],
			isTrue: true,
			isWaring: false,
			isWeek: false,
			isWeek2: false,
			waringArea: true,
			imgId: '',
			addTimeShow: false,
			copyTimeList: [],
			copyTimeList2: [],
			newArr: [],	// 存放转换为Number的时间段
			newArr2: [],	// 存放转换为Number的时间段
			timeList: [
				{
					startdate: '',
					behinddate: '',
					enddate: '',
					isShow: false,	// 隐藏删除时间段按钮标记
					errorFlag: false,	// true:stardate交叉, false:stardate不交叉
					errorFlag2: false	// true:enddate发生交叉，false:enddate不交叉
				}
			],
			timeList2: [
				{
					startdate: '',
					behinddate: '',
					enddate: '',
					isShow: false,	// 隐藏删除时间段按钮标记
					errorFlag: false,	// true:stardate交叉, false:stardate不交叉
					errorFlag2: false	// true:enddate发生交叉，false:enddate不交叉
				}
			],
			weekList: [
				{ name: '周一', id: '1' },
				{ name: '周二', id: '2' },
				{ name: '周三', id: '3' },
				{ name: '周四', id: '4' },
				{ name: '周五', id: '5' },
				{ name: '周六', id: '6' },
				{ name: '周日', id: '7' }
			],
			fixWeek: [],
			ruleForm: {
				selfPickName: '',
				selfPickLinkName: '',
				selfPickAddress: '',
				selfPickTel: '',
				selfPickMoney: '',
				showProvince: '',
				showCity: '',
				showDistrict: '',
				province: '',
				city: '',
				district: '',
				provinceName: '',
				cityName: '',
				districtName: '',
				week: [],
				week2: [],
				selfPickTimes: [
					{
						selfPickDate: '1,2,3',
						beginDate: '08:00',
						endDate: '17:00'
					}
				]
			},
			rules: {
				selfPickName: [
					{ required: true, validator: isNull, message: '请输入自提点名称', trigger: 'blur' }
				],
				selfPickLinkName: [
					{ required: true, validator: isNull, message: '请输入联系人姓名', trigger: 'blur' }
				],
				selfPickAddress: [
					{ required: true, validator: isNull, message: '请输入详细地址', trigger: 'blur' }
				],
				week: [
					{ required: true, validator: week, message: '请选择自提时间', trigger: 'blur' }
				],
				week2: [
					{ required: true, validator: week2, message: '请选择自提时间', trigger: 'blur' }
				],
				area: [
					{ required: true, validator: area, trigger: 'blur' }
				],
				postion: [
					{ required: true, validator: postion, trigger: 'blur' }
				],
				email: [
					{ type: 'email', required: true, message: '请输入正确的邮箱', trigger: 'blur' }
				],
				selfPickTel: [
					{ required: true, validator: phone, trigger: 'blur' }
				]
			},
			fxDataVerification: this.$fxUtils.fxDataVerification()
		}
	},
	created () {
		this.provinceListTotal = provinceData.RECORDS
		this.provinceList = provinceData.RECORDS
		this.areaList = geography
		this.getAuthority('01_0002_0000_00')
		if (this.$route.query.id) {
			this.id = this.$route.query.id
			this.init()
		}
	},
	methods: {
		goBack () {
			this.$router.push('/main/selfDelivery')
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		addTimeClick () {
			this.addTimeShow = true
		},
		delTimeClick () {
			this.addTimeShow = false
		},
		// 时间转换数字
		date2Number (date1, date2) {
			return date1 && date2 ? [+date1.split(':').join(''), +date2.split(':').join('')] : +date1.split(':').join('')
		},
		// 修改开始时间
		changeStartTime (e, i) {
			if (e.startdate) {
				let date = this.date2Number(e.startdate)
				let a = (date + 100) / 100
				e.behinddate = a >= 10 ? a + ':00' : '0' + a + ':00'
				this.newArr = []
				this.copyTimeList = this.timeList.concat()
				this.copyTimeList.forEach((item, index) => {
					if (item.startdate && item.enddate && i !== index) {
						this.newArr.push(this.date2Number(item.startdate, item.enddate))
					}
				})
				let len = this.copyTimeList.length
				let _BooleanArr = []
				if (len > 1) {
					this.newArr.forEach(item => {
						if ((date > item[0] || date === item[0]) && date < item[1]) {
							e.errorFlag = true
						} else {
							e.errorFlag = false
						}
						_BooleanArr.push(e.errorFlag)
					})
					e.errorFlag = _BooleanArr.some(item => { return item === true })
					// console.log(e)
				}
			} else {
				e.errorFlag = false
			}
			console.log(this.timeList)
		},
		// 修改结束时间
		changeEndTime (e, i) {
			if (e.enddate) {
				let date = this.date2Number(e.enddate)
				this.newArr = []
				this.copyTimeList = this.timeList.concat()
				this.copyTimeList.forEach((item, index) => {
					if (item.startdate && item.enddate && i !== index) {
						this.newArr.push(this.date2Number(item.startdate, item.enddate))
					}
				})
				let len = this.copyTimeList.length
				let _BooleanArr = []
				if (len > 1) {
					this.newArr.forEach(item => {
						if (date > item[0] && (date < item[1] || date === item[1])) {
							e.errorFlag2 = true
						} else {
							e.errorFlag2 = false
						}
						_BooleanArr.push(e.errorFlag2)
					})
					e.errorFlag2 = _BooleanArr.some(item => { return item === true })
				}
			} else {
				e.errorFlag2 = false
			}
		},
		// 修改开始时间
		changeStartTime2 (e, i) {
			if (e.startdate) {
				let date = this.date2Number(e.startdate)
				let a = (date + 100) / 100
				e.behinddate = a >= 10 ? a + ':00' : '0' + a + ':00'
				this.newArr = []
				this.copyTimeList2 = this.timeList2.concat()
				this.copyTimeList2.forEach((item, index) => {
					if (item.startdate && item.enddate && i !== index) {
						this.newArr2.push(this.date2Number(item.startdate, item.enddate))
					}
				})
				let len = this.copyTimeList2.length
				let _BooleanArr = []
				if (len > 1) {
					this.newArr2.forEach(item => {
						if ((date > item[0] || date === item[0]) && date < item[1]) {
							e.errorFlag = true
						} else {
							e.errorFlag = false
						}
						_BooleanArr.push(e.errorFlag)
					})
					e.errorFlag = _BooleanArr.some(item => { return item === true })
					// console.log(e)
				}
			} else {
				e.errorFlag = false
			}
		},
		// 修改结束时间
		changeEndTime2 (e, i) {
			if (e.enddate) {
				let date = this.date2Number(e.enddate)
				this.newArr = []
				this.copyTimeList2 = this.timeList2.concat()
				this.copyTimeList2.forEach((item, index) => {
					if (item.startdate && item.enddate && i !== index) {
						this.newArr2.push(this.date2Number(item.startdate, item.enddate))
					}
				})
				let len = this.copyTimeList2.length
				let _BooleanArr = []
				if (len > 1) {
					this.newArr2.forEach(item => {
						if (date > item[0] && (date < item[1] || date === item[1])) {
							e.errorFlag2 = true
						} else {
							e.errorFlag2 = false
						}
						_BooleanArr.push(e.errorFlag2)
					})
					e.errorFlag2 = _BooleanArr.some(item => { return item === true })
				}
			} else {
				e.errorFlag2 = false
			}
		},
		save (data) {
			// this.ruleForm.imgurl = data
			// this.ruleForm.name = this.ruleForm.orgname
			// const logger = this.$fxLogger.createInfo('seller.company-settging.update', this.createLoggerParams())
			// console.log(logger)
			let arr = this.$fxUtils.deepClone(this.ruleForm.week)
			if (arr.includes('0')) {
				let index = arr.indexOf('0')
				arr.splice(index, 1)
			}
			this.ruleForm.selfPickTimes[0] = {
				selfPickDate: arr.join(),
				beginDate: this.timeList[0].startdate,
				endDate: this.timeList[0].enddate
			}
			if (this.addTimeShow) {
				this.ruleForm.selfPickTimes[1] = {
					selfPickDate: this.ruleForm.week2.join(),
					beginDate: this.timeList2[0].startdate,
					endDate: this.timeList2[0].enddate
				}
			}
			this.ruleForm.province = JSON.parse(this.ruleForm.showProvince).id
			this.ruleForm.provinceName = JSON.parse(this.ruleForm.showProvince).name
			this.ruleForm.city = JSON.parse(this.ruleForm.showCity).id
			this.ruleForm.cityName = JSON.parse(this.ruleForm.showCity).name
			this.ruleForm.district = this.ruleForm.showDistrict
			this.ruleForm.id = this.id ? this.id : 0
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/saveOrUpdateShopSelfPickInfo`,
				data: this.ruleForm
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')
					this.goBack()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		createLoggerParams () {
			const originData = this.fxDataVerification.getOriginData()
			originData.areaName = this.getAreaName(originData.area)
			originData.positionName = this.getPositionName(originData)
			const ruleForm = this.$fxUtils.deepClone(this.ruleForm)
			ruleForm.areaName = this.getAreaName(ruleForm.area)
			ruleForm.positionName = this.getPositionName(ruleForm)
			return {
				pre: originData,
				cur: ruleForm
			}
		},
		getAreaName (code) {
			if (!code) {
				return ''
			}
			return (this.areaList.find(item => {
				return item.code === code
			}) || {}).name
		},
		getPositionName ({ province, city }) {
			if (!province || !city) {
				return ''
			}
			const _province = (this.provinceList.find(item => {
				return item.id === province
			}) || {}).name
			const _city = (this.cityList.find(item => {
				return item.id === city
			}) || {}).name
			return `${_province}-${_city}`
		},
		init () {
			let params = {
				id: this.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/getShopSelfPickInfoDetail`,
				data: params
			}).then(res => {
				if (res.result) {
					this.ruleForm = {
						selfPickName: res.data.selfPickName,
						selfPickLinkName: res.data.selfPickLinkName,
						selfPickAddress: res.data.address,
						selfPickTel: res.data.selfPickTel,
						selfPickMoney: this.$fxUtils.toFixedSHW(res.data.selfPickMoney, 2),
						showProvince: res.data.province,
						showCity: res.data.city,
						showDistrict: res.data.district,
						province: res.data.province,
						city: res.data.city,
						district: res.data.district,
						provinceName: res.data.provinceName,
						cityName: res.data.cityName,
						districtName: res.data.districtName,
						week: [],
						week2: [],
						selfPickTimes: [
							{
								selfPickDate: '1,2,3',
								beginDate: '08:00',
								endDate: '17:00'
							}
						]
					}
					let arr = res.data.selfPickTimes[0].selfPickDate.split(',')
					this.ruleForm.week = arr
					if (arr.length === 7) {
						arr.unshift('0')
						this.ruleForm.week = arr
					}
					this.fixWeek = this.ruleForm.week
					let timedate = this.date2Number(res.data.selfPickTimes[0].beginDate)
					let timeA = (timedate + 100) / 100
					let behinddate = timeA >= 10 ? timeA + ':00' : '0' + timeA + ':00'
					this.timeList = [
						{
							startdate: res.data.selfPickTimes[0].beginDate,
							behinddate: behinddate,
							enddate: res.data.selfPickTimes[0].endDate,
							isShow: false,	// 隐藏删除时间段按钮标记
							errorFlag: false,	// true:stardate交叉, false:stardate不交叉
							errorFlag2: false	// true:enddate发生交叉，false:enddate不交叉
						}
					]
					if (res.data.selfPickTimes.length === 2) {
						this.addTimeShow = true
						let arr2 = res.data.selfPickTimes[1].selfPickDate.split(',')
						this.ruleForm.week2 = arr2
						let timedate2 = this.date2Number(res.data.selfPickTimes[1].beginDate)
						let timeA2 = (timedate2 + 100) / 100
						let behinddate2 = timeA2 >= 10 ? timeA2 + ':00' : '0' + timeA2 + ':00'
						this.timeList2 = [
							{
								startdate: res.data.selfPickTimes[1].beginDate,
								behinddate: behinddate2,
								enddate: res.data.selfPickTimes[1].endDate,
								isShow: false,	// 隐藏删除时间段按钮标记
								errorFlag: false,	// true:stardate交叉, false:stardate不交叉
								errorFlag2: false	// true:enddate发生交叉，false:enddate不交叉
							}
						]
					}
					// this.provinceList = []
					this.cityList = []
					this.areaList = []
					// let b = this.provinceListTotal
					// for (let i = 0; i < b.length; i++) {
					// 	if (b[i].areacode === this.ruleForm.area) {
					// 		this.provinceList.push(b[i])
					// 	}
					// }
					let a = cityData.RECORDS
					for (let i = 0; i < a.length; i++) {
						if (this.ruleForm.showProvince === a[i].pid) {
							this.cityList.push(a[i])
						}
					}
					for (let i = 0; i < areaData.length; i++) {
						if (res.data.provinceName === areaData[i].name) {
							for (let j = 0; j < areaData[i].child.length; j++) {
								if (this.ruleForm.city === areaData[i].child[j].code) {
									this.areaList = areaData[i].child[j].child
								}
							}
						}
					}
					// for (let a = 0; a < this.areaList.length; a++) {
					// 	if (this.ruleForm.area === this.areaList[a].code) {
					// 		this.area = this.areaList[a].name
					// 	}
					// }
					for (let a = 0; a < this.provinceList.length; a++) {
						if (this.ruleForm.province === this.provinceList[a].id) {
							this.ruleForm.showProvince = JSON.stringify(this.provinceList[a])
						}
					}
					for (let a = 0; a < this.cityList.length; a++) {
						if (this.ruleForm.city === this.cityList[a].id) {
							this.ruleForm.showCity = JSON.stringify(this.cityList[a])
						}
					}
					this.fxDataVerification.resetData(this.ruleForm)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		weekChange () {
			let e = this.ruleForm.week
			e.sort()
			let newData
			let arr = ['1', '2', '3', '4', '5', '6', '7']
			if (e.length > this.fixWeek.length) {
				newData = e.filter(item => this.fixWeek.indexOf(item) === -1).join()
				if (newData === '0' || e.toString() === arr.toString()) {
					this.ruleForm.week = ['0', '1', '2', '3', '4', '5', '6', '7']
				}
			} else {
				newData = this.fixWeek.filter(item => e.indexOf(item) === -1).join()
				if (e.includes('0')) {
					let index = e.indexOf('0')
					e.splice(index, 1)
				}
				if (!e.includes('0') && e.length === 7) {
					this.ruleForm.week = []
				}
			}
			this.fixWeek = this.ruleForm.week
		},
		provinceChange (selVal, data) {
			this.changecity = true
			this.areaList = []
			this.ruleForm.showDistrict = ''
			this.cityList = []
			this.ruleForm.showCity = ''
			let a = cityData.RECORDS
			for (let i = 0; i < a.length; i++) {
				if (JSON.parse(this.ruleForm.showProvince).id === a[i].pid) {
					this.cityList.push(a[i])
				}
			}
			this.postionChange(data)
		},
		cityChange (selVal, data) {
			this.changearea = true
			// let province = this.changecity ? JSON.parse(this.ruleForm.province).name : this.ruleForm.province
			let province = JSON.parse(this.ruleForm.showProvince).name
			let city = JSON.parse(this.ruleForm.showCity).id
			this.areaList = []
			this.ruleForm.showDistrict = ''
			for (let i = 0; i < areaData.length; i++) {
				if (province === areaData[i].name) {
					for (let j = 0; j < areaData[i].child.length; j++) {
						if (city === areaData[i].child[j].code) {
							this.areaList = areaData[i].child[j].child
						}
					}
				}
			}
			this.postionChange(data)
		},
		districtChange (selVal, data) {
			this.postionChange(data)
			for (let a = 0; a < this.areaList.length; a++) {
				if (this.ruleForm.showDistrict === this.areaList[a].code) {
					this.ruleForm.districtName = this.areaList[a].name
					break
				}
			}
		},
		postionChange (formName) {
			if (this.ruleForm.showProvince === '' || this.ruleForm.showCity === '' || this.ruleForm.showDistrict === '') {
				this.isTrue = true
			} else {
				this.isTrue = false
			}
			this.$refs[formName].validateField('postion', (error) => {
				if (!error) {
					return true
				} else {
					return false
				}
			})
		},
		submitForm (formName) {
			if (this.ruleForm.showProvince === '' || this.ruleForm.showCity === '') {
				this.isTrue = true
			} else {
				this.isTrue = false
			}
			if (this.ruleForm.week.length === 0 || !this.timeList[0].startdate || !this.timeList[0].enddate) {
				this.isWeek = true
			} else {
				this.isWeek = false
			}
			if (this.addTimeShow && (this.ruleForm.week2.length === 0 || !this.timeList2[0].startdate || !this.timeList2[0].enddate)) {
				this.isWeek2 = true
			} else {
				this.isWeek2 = false
			}
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.save()
				}
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
.business{
    width :100%;
    min-width :720px;
    height :100%;
    display: flex;
	flex-direction: column;
	.store-name {
		border-bottom: 1px solid #dce2fd;
		height:66px;
		min-height: 66px;
		line-height: 66px;
		box-sizing border-box
		span {
			font-size: 18px;
			font-weight: bold
			float left
			display inline-block
			line-height 66px
			padding-right 20px
			i {
				border-radius: 50%;
				background: #9da6af;
				padding: 3px;
				cursor: pointer;
			}
			.el-icon-back:before {
				content: "\E6EA";
				color: #fff;
				font-weight: bold;
			}
		}
	}
	.time-btn {
		color: var(--fx-primary-color);
		border-color: var(--fx-primary-color);
		padding: 2px;
	}
	.date-box {
		width: 200px
	}
    .star{
        color: #F56C6C;
        margin-right: 4px;
        width:10px;
        position: relative;
        right: 292px;
        top: 26px;
    }
    .waring{
        height :14px;
        color: #F56C6C;
        font-size: 12px;
        position: relative;
        text-align :left;
        padding-left :110px;
        bottom: 20px;
    }
    .business-body{
        height :100%;
        overflow-y :auto;
        margin-bottom :20px;
        padding: 30px 0 30px 10px;
        border-radius :0px 0px 10px 10px;
        .business-picture{
            text-align:center;
            width :210px;
            height :200px;
            margin-left :100px
        }
        .box{
            width :100%
            .input-box{
                width :200px;
            }
            .input-box-address{
                 width :500px;
            }
            .select-box{
                width :200px;
                margin-right :20px;
            }
            .select-box1{
                width :200px;
            }
            .el-form-item >>> .el-form-item__content{
                text-align :left
            }
        }
    }
    .business-foot{
        position: relative;
        height :40px;
        margin-bottom :10px;
        text-align: left
        .btn{
            width :130px;
			height :35px;
			margin-left :20px;
        }
    }
}
</style>
<style lang="stylus">
	.el-textarea__inner {
		font-family: 'Microsoft Yahei' !important
	}
</style>
